import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 投注游戏组件属性接口 */
export interface BetGameAttrs extends BaseComponentAttrs {
  /** 标题图标 */
  // title_icon: string;
  // /** 标题文本 */
  // title_text: LangText;
  // /** 标题类型 */
  // title_type: number;
}

/** 投注游戏组件类 */
export class BetGameComponent extends BaseComponent<BetGameAttrs> {
  constructor(data: Partial<BaseComponent<BetGameAttrs>> = {}) {
    super(data);
    this.type = CompType.bet_game;
  }

  /** 获取标题图标 */
  // public getTitleIcon(): string {
  //   return this.attrs.title_icon;
  // }

  // /** 设置标题图标 */
  // public setTitleIcon(icon: string): void {
  //   this.setAttrs({ title_icon: icon });
  // }

  // /** 获取标题文本 */
  // public getTitleText(): Record<string, string> {
  //   return this.attrs.title_text;
  // }

  // /** 设置标题文本 */
  // public setTitleText(text: Record<string, string>): void {
  //   this.setAttrs({ title_text: text });
  // }

  // /** 获取指定语言的标题 */
  // public getTitleByLang(lang: string): string {
  //   return this.attrs.title_text?.[lang] || "";
  // }

  // /** 获取标题类型 */
  // public getTitleType(): number {
  //   return this.attrs.title_type;
  // }

  // /** 设置标题类型 */
  // public setTitleType(type: number): void {
  //   this.setAttrs({ title_type: type });
  // }
}
